import { DEFAULT_PAGE_SIZE } from "Data/constants";
import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  error: null,
  appName: null,
  loader: false,
  apps: [],
  ongoingProcess: [],
  completedProcess: [],
  openBucketProcess: [],
  openBucketCount: 0,
  reworkBucketProcess: [],
  reworkBucketCount: 0,
  assignedBucketProcess: [],
  assignedBucketCount: 0,
  submittedBucketProcess: [],
  submittedBucketCount: 0,
  qcAllocatedBucketProcess: [],
  qcAllocatedBucketCount: 0,
  qcDoneBucketProcess: [],
  qcDoneBucketCount: 0,
  qcRejectedBucketProcess: [],
  qcRejectedBucketCount: 0,
  withdrawn: [],
  withdrawnCount: 0,
  ongoingCount: 0,
  completedCount: 0,
  offset: 1,
  processType: "",
  process_key: "",
  currentTask: [],
  appData: null,
  formContent: null,
  formName: "",
  formDescription: "",
  message: "",
  searchCount: null,
  selected_card_list: [],
  selectAll: true,
  searchResults: null,
  searchData: null,
  submissionData: {},
  size: DEFAULT_PAGE_SIZE,
  processStateFilter: null,
  allAppsAdvFilterQuery: [],
  allAppsAdvTaskFilterQuery: [],
  showProcessSearchBar: true,
  dateValueAdvFilter: null,
};

const selectedProcessType = (state, action) => {
  return updateObject(state, {
    loader: false,
    processType: action.processType,
    offset: 1,
    selected_card_list: [],
  });
};

const setDateValueAdvFilter = (state, action) => {
  return updateObject(state, {
    dateValueAdvFilter: action.dateValueObj,
  });
};

const processStart = (state) => {
  return updateObject(state, {
    loader: true,
  });
};

const processSuccess = (state, action) => {
  return updateObject(state, {
    loader: false,
    apps: action.apps,
    appData: action.app,
    appName: action.name,
    withdrawn: action.withdrawn,
    withdrawnCount: action.withdrawnCount,
    openBucketProcess: action.openBucket,
    openBucketCount: action.openBucketCount,
    reworkBucketProcess: action.reworkBucket,
    reworkBucketCount: action.reworkBucketCount,
    assignedBucketProcess: action.assignedBucket,
    assignedBucketCount: action.assignedBucketCount,
    submittedBucketProcess: action.submittedBucket,
    submittedBucketCount: action.submittedBucketCount,
    qcAllocatedBucketProcess: action.qcAllocatedBucket,
    qcAllocatedBucketCount: action.qcAllocatedBucketCount,
    qcDoneBucketProcess: action.qcDoneBucket,
    qcDoneBucketCount: action.qcDoneBucketCount,
    qcRejectedBucketProcess: action.qcRejectedBucket,
    qcRejectedBucketCount: action.qcRejectedBucketCount,
    ongoingProcess: action.ongoing,
    ongoingCount: action.ongoingCount,
    completedProcess: action.completed,
    completedCount: action.completedCount,
    offset: action.offset,
    selectedFormFields: action.selectedFormFields,
    process_key: action.process_key,
    searchResults: null,
    selected_card_list: [],
    processType: action.process_type,
    size: action.size,
    searchData: null,
    filteredOptions: action.filterOptions,
    selectedOption: action.selectedOption,
    processStateFilter: action.processStateFilter,
    allAppsAdvFilterQuery: action.allAppsAdvFilterQuery,
  });
};

const processOnGoing = (state, action) => {
  return updateObject(state, {
    loader: false,
    ongoingProcess: action.ongoing,
    ongoingCount: action.total,
    offset: action.offset,
  });
};

const processOpenBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    openBucketProcess: action.openBucket,
    openBucketCount: action.total,
    offset: action.offset,
  });
};

const processReworkBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    reworkBucketProcess: action.reworkBucket,
    reworkBucketCount: action.total,
    offset: action.offset,
  });
};

const processAssignedBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    assignedBucketProcess: action.assignedBucket,
    assignedBucketCount: action.total,
    offset: action.offset,
  });
};

const processSubmittedBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    submittedBucketProcess: action.submittedBucket,
    submittedBucketCount: action.total,
    offset: action.offset,
  });
};

const processQcAllocatedBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    qcAllocatedBucketProcess: action.qcAllocatedBucket,
    qcAllocatedBucketCount: action.total,
    offset: action.offset,
  });
};

const processQcDoneBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    qcDoneBucketProcess: action.qcDoneBucket,
    qcDoneBucketCount: action.total,
    offset: action.offset,
  });
};

const processQcRejectedBucket = (state, action) => {
  return updateObject(state, {
    loader: false,
    qcRejectedBucketProcess: action.qcRejectedBucket,
    qcRejectedBucketCount: action.total,
    offset: action.offset,
  });
};

const processCompleted = (state, action) => {
  return updateObject(state, {
    loader: false,
    completedProcess: action.completed,
    completedCount: action.total,
    offset: action.offset,
  });
};

const processDetails = (state, action) => {
  return updateObject(state, {
    loader: false,
    appName: action.name,
    withdrawn: action.withdrawn,
    withdrawnCount: action.withdrawnCount,
    ongoingProcess: action.ongoing,
    openBucketProcess: action.openBucket,
    openBucketCount: action.openBucketCount,
    reworkBucketProcess: action.reworkBucket,
    reworkBucketCount: action.reworkBucketCount,
    assignedBucketProcess: action.assignedBucket,
    assignedBucketCount: action.assignedBucketCount,
    submittedBucketProcess: action.submittedBucket,
    submittedBucketCount: action.submittedBucketCount,
    qcAllocatedBucketProcess: action.qcAllocatedBucket,
    qcAllocatedBucketCount: action.qcAllocatedBucketCount,
    qcDoneBucketProcess: action.qcDoneBucket,
    qcDoneBucketCount: action.qcDoneBucketCount,
    qcRejectedBucketProcess: action.qcRejectedBucket,
    qcRejectedBucketCount: action.qcRejectedBucketCount,
    completedProcess: action.completed,
    ongoingCount: action.ongoingCount,
    completedCount: action.completedCount,
    offset: 1,
    selectedFormFields: action.selectedFormFields,
    process_key: action.process_key,
    appData: action.app,
    selected_card_list: [],
    searchResults: null,
    searchData: null,
    filteredOptions: action.filteredOptions,
    selectedOption: action.selectedOption,
    processStateFilter: action.processStateFilter,
  });
};

const processLaunch = (state) => {
  return updateObject(state, {
    // loader: false,
    formStart: false,
  });
};

const processWithdraw = (state, action) => {
  return updateObject(state, {
    loader: false,
    withdrawn: [
      ...state.withdrawn.concat([
        ...state.ongoingProcess.filter((process) => process.id === action.id),
        ...state.openBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.reworkBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.assignedBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.submittedBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.qcAllocatedBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.qcDoneBucketProcess.filter(
          (process) => process.id === action.id
        ),
        ...state.qcRejectedBucketProcess.filter(
          (process) => process.id === action.id
        ),
      ]),
    ],
    ongoingProcess: [
      ...state.ongoingProcess.filter((process) => process.id !== action.id),
    ],
    openBucketProcess: [
      ...state.openBucketProcess.filter((process) => process.id !== action.id),
    ],
    reworkBucketProcess: [
      ...state.reworkBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    assignedBucketProcess: [
      ...state.assignedBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    submittedBucketProcess: [
      ...state.submittedBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    qcAllocatedBucketProcess: [
      ...state.qcAllocatedBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    qcDoneBucketProcess: [
      ...state.qcDoneBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    qcRejectedBucketProcess: [
      ...state.qcRejectedBucketProcess.filter(
        (process) => process.id !== action.id
      ),
    ],
    error: null,
    withdrawnCount: state.withdrawnCount + 1,
  });
};

const processFail = (state, action) => {
  return updateObject(state, {
    loader: false,
    processes: action.process,
    tasks: action.tasks,
  });
};

const startProcess = (state, action) => {
  return updateObject(state, {
    loader: false,
    formContent: action.formData.content,
    formName: action.formData.name,
    formDescription: action.formData.description,
    submissionData: action.submission_data,
  });
};

const startProcessError = (state) => {
  return updateObject(state, {
    loader: false,
  });
};
const processSelected = (state, action) => {
  return updateObject(state, {
    selected_card_list: action.event
      ? [
          ...state.selected_card_list,
          {
            id: action.id,
            email: action.email,
            selected: action.event,
            phone: action.phone,
          },
        ]
      : [...state.selected_card_list.filter((e) => e.id !== action.id)],
    selectAll: action.selected_all,
  });
};

const processSelectedAll = (state, action) => {
  return updateObject(state, {
    selected_card_list: action.selected_all,
  });
};

const processSelectedClear = (state) => {
  return updateObject(state, {
    selected_card_list: [],
  });
};

const launchProcessError = (state) => {
  return updateObject(state, {
    loader: false,
  });
};

const getTaskUsers = (state, action) => {
  return updateObject(state, {
    taskUsers: action.data,
  });
};

const processWithdrawPagination = (state, action) => updateObject(state, {
    loader: false,
    withdrawn: action.withdrawn,
    withdrawnCount: action.total,
    offset: action.offset,
  });

const processSearchResult = (state, action) => {
  if (action.processType === "Ongoing process") {
    return updateObject(state, {
      loader: false,
      ongoingProcess: action.results.ongoing.data,
      ongoingCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "Completed process") {
    return updateObject(state, {
      loader: false,
      completedProcess: action.results.completed.data,
      completedCount: action.results.completed.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "open process") {
    return updateObject(state, {
      loader: false,
      openBucketProcess: action.results.ongoing.data,
      openBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "rework process") {
    return updateObject(state, {
      loader: false,
      reworkBucketProcess: action.results.ongoing.data,
      reworkBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "assigned process") {
    return updateObject(state, {
      loader: false,
      assignedBucketProcess: action.results.ongoing.data,
      assignedBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "submitted process") {
    return updateObject(state, {
      loader: false,
      submittedBucketProcess: action.results.ongoing.data,
      submittedBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "qcAllocated process") {
    return updateObject(state, {
      loader: false,
      qcAllocatedBucketProcess: action.results.ongoing.data,
      qcAllocatedBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "qcDone process") {
    return updateObject(state, {
      loader: false,
      qcDoneBucketProcess: action.results.ongoing.data,
      qcDoneBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  if (action.processType === "qcRejected process") {
    return updateObject(state, {
      loader: false,
      qcRejectedBucketProcess: action.results.ongoing.data,
      qcRejectedBucketCount: action.results.ongoing.total,
      searchData: action.searchData,
      offset: action.offset ? action.offset : 1,
    });
  }
  return updateObject(state, {
    loader: false,
    withdrawn: action.results.withdrawn.data,
    withdrawnCount: action.results.withdrawn.total,
    searchData: action.searchData,
    offset: action.offset ? action.offset : 1,
  });
};

const processSearchCount = (state, action) => {
  if (action.process_type === "Ongoing process") {
    return updateObject(state, {
      loader: false,
      ongoingCount: action.count,
      ongoingProcess: action.data,
    });
  }
  if (action.process_type === "open process") {
    return updateObject(state, {
      loader: false,
      openBucketCount: action.count,
      openBucketProcess: action.data,
    });
  }
  if (action.process_type === "rework process") {
    return updateObject(state, {
      loader: false,
      reworkBucketCount: action.count,
      reworkBucketProcess: action.data,
    });
  }
  if (action.process_type === "assigned process") {
    return updateObject(state, {
      loader: false,
      assignedBucketCount: action.count,
      assignedBucketProcess: action.data,
    });
  }
  if (action.process_type === "submitted process") {
    return updateObject(state, {
      loader: false,
      submittedBucketCount: action.count,
      submittedBucketProcess: action.data,
    });
  }
  if (action.process_type === "qcAllocated process") {
    return updateObject(state, {
      loader: false,
      qcAllocatedBucketCount: action.count,
      qcAllocatedBucketProcess: action.data,
    });
  }
  if (action.process_type === "qcDone process") {
    return updateObject(state, {
      loader: false,
      qcDoneBucketCount: action.count,
      qcDoneBucketProcess: action.data,
    });
  }
  if (action.process_type === "qcRejected process") {
    return updateObject(state, {
      loader: false,
      qcRejectedBucketCount: action.count,
      qcRejectedBucketProcess: action.data,
    });
  }
  if (action.process_type === "Completed process") {
    return updateObject(state, {
      loader: false,
      completedCount: action.count,
      completedProcess: action.data,
    });
  }
  if (action.process_type === "Withdrawn process") {
    return updateObject(state, {
      loader: false,
      withdrawnCount: action.count,
      withdrawn: action.data,
    });
  }
  return true;
};
const clearProcessSearch = (state) => {
  return updateObject(state, {
    loader: false,
    searchResults: null,
    searchData: null,
  });
};

const setProcessFilter = (state, action) => {
  return updateObject(state, {
    filteredOptions: action.filteredOptions,
    selectedOption: action.selectedOption,
  });
};

const updateAdvFilter = (state, action) => {
  let { allAppsAdvFilterQuery } = state;
  allAppsAdvFilterQuery[action.processKey] = action.filterQuery;
  return updateObject(state, {
    loader: false,
    ongoingProcess: action.ongoing,
    openBucketProcess: action.openBucket,
    openBucketCount: action.openBucketCount,
    reworkBucketProcess: action.reworkBucket,
    reworkBucketCount: action.reworkBucketCount,
    assignedBucketProcess: action.assignedBucket,
    assignedBucketCount: action.assignedBucketCount,
    submittedBucketProcess: action.submittedBucket,
    submittedBucketCount: action.submittedBucketCount,
    qcAllocatedBucketProcess: action.qcAllocatedBucket,
    qcAllocatedBucketCount: action.qcAllocatedBucketCount,
    qcDoneBucketProcess: action.qcDoneBucket,
    qcDoneBucketCount: action.qcDoneBucketCount,
    qcRejectedBucketProcess: action.qcRejectedBucket,
    qcRejectedBucketCount: action.qcRejectedBucketCount,
    completedProcess: action.completed,
    withdrawn: action.withdrawn,
    allAppsAdvFilterQuery: allAppsAdvFilterQuery,
    ongoingCount: action.ongoingCount,
    completedCount: action.completedCount,
    withdrawnCount: action.withdrawnCount,
  });
};

const updateAdvFilterInTask = (state, action) => {
  let { allAppsAdvTaskFilterQuery } = state;
  allAppsAdvTaskFilterQuery[action.processKey] = action.filterQuery;
  return updateObject(state, {
    loader: false,
    ongoingProcess: action.ongoing,
    openBucketProcess: action.openBucket,
    openBucketCount: action.openBucketCount,
    reworkBucketProcess: action.reworkBucket,
    reworkBucketCount: action.reworkBucketCount,
    assignedBucketProcess: action.assignedBucket,
    assignedBucketCount: action.assignedBucketCount,
    submittedBucketProcess: action.submittedBucket,
    submittedBucketCount: action.submittedBucketCount,
    qcAllocatedBucketProcess: action.qcAllocatedBucket,
    qcAllocatedBucketCount: action.qcAllocatedBucketCount,
    qcDoneBucketProcess: action.qcDoneBucket,
    qcDoneBucketCount: action.qcDoneBucketCount,
    qcRejectedBucketProcess: action.qcRejectedBucket,
    qcRejectedBucketCount: action.qcRejectedBucketCount,
    completedProcess: action.completed,
    withdrawn: action.withdrawn,
    allAppsAdvTaskFilterQuery: allAppsAdvTaskFilterQuery,
    ongoingCount: action.ongoingCount,

    completedCount: action.completedCount,
    withdrawnCount: action.withdrawnCount,
  });
};

const setProcessSize = (state, action) => {
  return updateObject(state, {
    size: action.size,
    offset: 1,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PROCESS_START:
      return processStart(state, action);
    case actionTypes.START_PROCESS_FORM:
      return startProcess(state, action);
    case actionTypes.PROCESS_SUCCESS:
      return processSuccess(state, action);
    case actionTypes.PROCESS_DETAILS:
      return processDetails(state, action);
    case actionTypes.PROCESS_LAUNCH:
      return processLaunch(state);
    case actionTypes.PROCESS_ERROR:
      return processFail(state, action);
    case actionTypes.PROCESS_DETAILS_PAGINATION:
      return processOnGoing(state, action);
    case actionTypes.PROCESS_OPEN_BUCKET:
      return processOpenBucket(state, action);
    case actionTypes.PROCESS_REWORK_BUCKET:
      return processReworkBucket(state, action);
    case actionTypes.PROCESS_ASSIGNED_BUCKET:
      return processAssignedBucket(state, action);
    case actionTypes.PROCESS_SUBMITTED_BUCKET:
      return processSubmittedBucket(state, action);
    case actionTypes.PROCESS_QC_ALLOCATED_BUCKET:
      return processQcAllocatedBucket(state, action);
    case actionTypes.PROCESS_QC_DONE_BUCKET:
      return processQcDoneBucket(state, action);
    case actionTypes.PROCESS_QC_REJECTED_BUCKET:
      return processQcRejectedBucket(state, action);
    case actionTypes.PROCESS_DETAILS_COMPLETED:
      return processCompleted(state, action);
    case actionTypes.SELECT_DETAILS:
      return selectedProcessType(state, action);
    case actionTypes.SET_DATE_VALUE:
      return setDateValueAdvFilter(state, action);
    case actionTypes.PROCESS_WITHDRAW:
      return processWithdraw(state, action);
    case actionTypes.START_PROCESS_ERROR:
      return startProcessError(state);
    case actionTypes.PROCESS_LAUNCH_ERROR:
      return launchProcessError(state);
    case actionTypes.GET_TASK_USERS:
      return getTaskUsers(state, action);
    case actionTypes.WITHDRAWN_PROCESS_PAGINATION:
      return processWithdrawPagination(state, action);
    case actionTypes.PROCESS_SEARCH:
      return processSearchResult(state, action);
    case actionTypes.SELECT_CARD_DETAILS:
      return processSelected(state, action);
    case actionTypes.CLEAR_ALL:
      return processSelectedClear(state, action);
    case actionTypes.SELECT_CARD_ALL:
      return processSelectedAll(state, action);
    case actionTypes.CLEAR_SEARCH:
      return clearProcessSearch(state);
    case actionTypes.PROCESS_SEARCH_COUNT:
      return processSearchCount(state, action);
    case actionTypes.FILTER_FROM_DASHBOARD:
      return setProcessFilter(state, action);
    case actionTypes.UPDATE_ADVANCED_FILTER:
      return updateAdvFilter(state, action);
    case actionTypes.UPDATE_ADVANCED_FILTER_TASK:
      return updateAdvFilterInTask(state, action);
    case actionTypes.TOGGLE_PROCESS_SEARCH_BAR:
      return {
        ...state,
        showProcessSearchBar: action.show,
      };
    case actionTypes.UPDATE_SEARCH_DATA:
      return {
        ...state,
        searchData: action.searchData,
      };
    case actionTypes.CLEAR_ALL_PROCESS:
      return {
        ...state,
        ongoingProcess: [],
        openBucketProcess: [],
        openBucketCount: 0,
        reworkBucketProcess: [],
        reworkBucketCount: 0,
        assignedBucketProcess: [],
        assignedBucketCount: 0,
        submittedBucketProcess: [],
        submittedBucketCount: 0,
        qcAllocatedBucketProcess: [],
        qcAllocatedBucketCount: 0,
        qcDoneBucketProcess: [],
        qcDoneBucketCount: 0,
        qcRejectedBucketProcess: [],
        qcRejectedBucketCount: 0,
        completedProcess: [],
        withdrawn: [],
        withdrawnCount: 0,
        ongoingCount: 0,
        completedCount: 0,
        size: DEFAULT_PAGE_SIZE,
        processType: "",
      };
    case actionTypes.SET_PROCESS_SIZE:
      return setProcessSize(state, action);
    default:
      return state;
  }
};

export default reducer;
